var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hg-account-button'),_c('hg-menu-list'),_c('hg-report-menu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }